import { NgModule } from '@angular/core'
import { ColorContainerFeatureModule } from './color-container-feature.module'
import {
  ColorContainerContentOverviewFeatureModule
} from './color-container-navigation/color-container-content-overview/color-container-content-overview-feature.module'

@NgModule({
  imports: [
    ColorContainerContentOverviewFeatureModule,
    ColorContainerFeatureModule
  ]
})
export class ColorContainerRootModule {
}
